import {registerStyle, styleRule, StyleSheet, UI} from "../../../stem-core/src/ui/UI.js";
import {ActiveButton} from "../../../blinkpay/ui/Button.jsx";
import {InputableElement} from "../../../stem-core/src/ui/input/Input.jsx";
import {InputLabel} from "./InputLabel.jsx";


export class RadioButtonsInputStyle extends StyleSheet {
    @styleRule
    container = {
        display: "inline-block",
        margin: 8
    }

    @styleRule
    radioButtons = {
        display: "flex",
        width: "100%",
        ">:first-child": {
            marginLeft: 0,
            borderRadius: "4px 0 0 4px",
        },
        ">:last-child": {
            marginRight: 0,
            borderRadius: "0 4px 4px 0",
        },
    };

    @styleRule
    button = {
        padding: this.themeProps.RADIO_BUTTON_PADDING,
        flex: this.themeProps.RADIO_BUTTON_FLEX,
    };
}

@registerStyle(RadioButtonsInputStyle)
export class RadioButtonsInput extends InputableElement {
    // ----------- COMMON API ---------
    getValue() {
        return this.value;
    }

    setValue(value, dispatchChange=true) {
        if (this.isEqual(this.value, value)) {
            return;
        }
        this.value = value;
        if (this.node) {
            this.redraw();
        }
        if (dispatchChange) {
            this.dispatchChange(value);
        }
    }

    isEqual(valueA, valueB) {
        return valueA === valueB;
    }

    setOptions(options) {
        const oldInitialValue = this.options.initialValue;
        super.setOptions(options);
        const {initialValue} = this.options;
        if (this.value === undefined || !this.node || !this.isEqual(initialValue, oldInitialValue)) {
            this.setValue(initialValue);
        }
    }

    addChangeListener(callback) {
        return this.addListener("change", callback);
    }
    // ----------- END OF COMMON API ---------

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            initialValue: null,
            label: null
        };
    }

    renderActiveButtons() {
        const {styleSheet} = this;

        return this.options.values.map(value => (
            <ActiveButton
                label={value}
                active={value === this.getValue()}
                onClick={() => this.setValue(value)}
                className={styleSheet.button}
            />
        ));
    }

    render() {
        const {styleSheet} = this;
        const {label} = this.options;

        return [
            label && <InputLabel label={label} />,
            <div className={styleSheet.radioButtons}>
                {this.renderActiveButtons()}
            </div>
        ];
    }

    getActive() {
        return this.getValue();
    }
}